import AOS from 'aos';
import 'aos/dist/aos.css';
import parse from "html-react-parser";
import { useEffect } from "react";
import CallToActionSmall from "../components/v2/call-to-action-sm";
import "../styles/scss/content.module.scss";
import '../styles/scss/_trusted-companies.module.scss';


const ContentPageTemplate = ({pageData }) => {
    const accordianselect = (e) => {
        e.target.classList.toggle("active");

        const panelParent = e.target.closest(".accordian-section");

        if (panelParent) {
            const panel = panelParent.querySelector(".panel");

            if (panel && (panel.style.display === "none" || panel.style.display === "")) {
                panel.style.display = "block";
            } else if (panel) {
                panel.style.display = "none";
            }
        }
    };

    useEffect(() => {
        let list = [];
        const listItems = document.querySelector('.content-nav-list')?.querySelectorAll('li');

        if (listItems) {
            list = Array.from(listItems).map(li => li.querySelector('a'));
        }

        const accordions = document.querySelectorAll('.accordion');

        AOS.init({
            duration: 1500,
            once: true,
            disable: 'mobile',
        });
        addTitle();
        window.addEventListener('scroll', scrollEvent);

        list.forEach(child => {
            if (child) {
                child.addEventListener('click', clickEvent);
            }
        });

        accordions.forEach(ac => {
            ac.addEventListener('click', accordianselect);
        });

        return () => {
            window.removeEventListener('scroll', scrollEvent);
            list.forEach(child => {
                if (child) {
                    child.removeEventListener('click', clickEvent);
                }
            });
            accordions.forEach(ac => {
                ac.removeEventListener('click', accordianselect);
            });
        }
    }, []);

    const addTitle = () => {
        const list = document.querySelectorAll('.content-page-title');
        list.forEach((child, index) => {
            if (child) {
                child.setAttribute("id", `content-title-${index}`);
            }
        });
    };

    const scrollEvent = () => {
        const scrollDistance = window.scrollY;
        const elements = document.querySelectorAll('.content-page-title');
        const ul = document.querySelector('.content-nav-list');

        elements.forEach((element, index) => {
            const child = element as HTMLElement;
            if (child && child.offsetTop - 83 <= scrollDistance) {
                const active = ul?.querySelector('.active');
                if (active) active.classList.remove('active');
                const li = ul?.querySelectorAll('li')[index];
                if (li) li.classList.add('active');
            }
        });
    };

    const clickEvent = (e) => {
        e.preventDefault();
        const target = e.target.hash;
        const id = target.substring(1);
        const element = document.getElementById(id);
        if (element) scrollTo(element);
    };

    const scrollTo = (element) => {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop - 83
        });
    };

    return <>

        <div className={`middle-wrapper site-page ${pageData.slug}-page`}>
            {pageData?.pages.edges[0].node.content ? parse(pageData?.pages.edges[0].node.content) : <div className={'container'}><div className={'coming-soon'}><h1>Coming soon</h1></div></div>}
            <CallToActionSmall/>
        </div>
    </>
}

export default ContentPageTemplate